import { Link, Paper, Typography } from '@mui/material';
import React from 'react';

import { MessageKey, useT } from '../i18n';
import { config } from '../monetization/config';

import { PageShell } from './components/PageShell';

const Q: React.FC<{ q: string; children: React.ReactNode }> = ({
    q,
    children,
}) => (
    <>
        <Typography variant="h6" component="h3" sx={{ mt: 2 }}>
            {q}
        </Typography>
        <Typography paragraph>{children}</Typography>
    </>
);

/** Plain, readable page about the app and how a reading is made: real content for visitors and for ad review. */
export const AboutPage: React.FC = () => {
    const t = useT();
    const p = (key: MessageKey) => <Typography paragraph>{t(key)}</Typography>;
    return (
        <PageShell to="/">
            <Paper
                component="article"
                sx={{ p: { xs: 2.5, sm: 4 }, background: 'rgba(21,14,36,.88)' }}
            >
                <Typography variant="h4" component="h1" gutterBottom>
                    {t('about.title')}
                </Typography>
                {p('about.intro')}
                <Typography variant="h5" component="h2" sx={{ mt: 3 }}>
                    {t('about.howTitle')}
                </Typography>
                {p('about.how1')}
                {p('about.how2')}
                {p('about.how3')}
                <Typography variant="h5" component="h2" sx={{ mt: 3 }}>
                    {t('about.creditsTitle')}
                </Typography>
                {p('about.credits')}
                {p('about.creditsChart')}
                <Typography variant="h5" component="h2" sx={{ mt: 3 }}>
                    {t('about.faqTitle')}
                </Typography>
                <Q q={t('about.q1')}>{t('about.a1')}</Q>
                <Q q={t('about.q2')}>{t('about.a2')}</Q>
                <Q q={t('about.q3')}>{t('about.a3')}</Q>
                <Q q={t('about.q4')}>
                    {t('about.a4')}{' '}
                    <Link href={`mailto:${config.supportEmail}`}>
                        {config.supportEmail}
                    </Link>
                    .
                </Q>
            </Paper>
        </PageShell>
    );
};
